import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// 移动端检测，在 React 渲染前执行
(function detectMobile() {
  const userAgent = navigator.userAgent;
  // 检测常规移动设备
  const hasMobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(userAgent);
  // 检测鸿蒙系统
  const hasHarmonyOS = /HarmonyOS/i.test(userAgent);

  // 检测是否为移动设备（通过屏幕尺寸判断）
  const isMobileScreen = window.innerWidth < 768;
  
  // 常规移动设备直接跳转
  if (hasMobileUA) {
    window.location.href = 'https://culture.hnbxwhy.com/yh/#/';
    return;
  }
  
  // 鸿蒙系统：只有屏幕尺寸小于768px才认为是移动端
  if (hasHarmonyOS && isMobileScreen) {
    window.location.href = 'https://culture.hnbxwhy.com/yh/#/';
  }
})();

ReactDOM.render(
  // <React.StrictMode>
  //   <App />
  // </React.StrictMode>,
 <App />,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
